export enum ContractType {
  AOC_TOKEN = 'AOC Main Contract',
  BULK_TOKEN = 'AOC Token Distribution Contract',
  AOC_LOCKER = 'AOC Token Locker Contract'
}
